import __request__ from "routing/request";
export function listConfigurationVariables(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createConfigurationVariable(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateConfigurationVariable(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfigurationVariable(id, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteConfigurationVariable(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfigurationVariablesConfigurations(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.sidecar/sidecar/configuration_variables/${id}/configurations`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
